import { Component } from '@angular/core';

@Component({
    selector: 'netfoundry-ui-service-policies-extension',
    templateUrl: './service-policies-extension.component.html',
    standalone: false,
})
export class ServicePoliciesExtensionComponent {
}
